import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { productionOrderStates as state } from '../../Config/productionOrderStates'
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import { useTranslation } from 'react-i18next';


export default function ChangeStatePopoverContent(props) {
    const classes = useStyles();

    const [states, setStates] = React.useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        let mounted = true

        if (mounted) {
            let orderStates = [state.RUNNING, state.PAUSED, state.STOPPED]
            if (orderStates.some(x => x === props.state)) {
                let index = orderStates.indexOf(orderStates.find(x => x === props.state))
                orderStates.splice(index, 1)
            }
            setStates(orderStates)
        }

        return function cleanup() {
            mounted = false
        }
    }, [props.state]);

    return (
        <div className={classes.popoverContent} style={{width:props.popoverWidth}}>
            {states.map(x => {
                return (
                    x === state.RUNNING ? <React.Fragment key={x}>
                        <div className={classes.borderLeft}></div>
                        <button className={classes.stateElement} onClick={() => props.changeState(state.RUNNING)}>
                            <PlayArrowRoundedIcon className={classes.play}></PlayArrowRoundedIcon>
                            <span className={classes.action}>
                            {t("START")}
                            </span>
                        </button>
                        <div className={classes.borderRight}></div>
                    </React.Fragment>
                        :
                        x === state.PAUSED ?
                            <React.Fragment key={x}>
                                <div className={classes.borderLeft}></div>
                                <button className={classes.stateElement} onClick={() => props.changeState(state.PAUSED)}>
                                    <PauseRoundedIcon className={classes.pause} ></PauseRoundedIcon>
                                    <span className={classes.action}>
                                    {t("PAUSE")}
                                </span>
                                </button>
                                <div className={classes.borderRight}></div>
                            </React.Fragment>
                            :
                            x === state.STOPPED ?
                                <React.Fragment key={x}>
                                    <div className={classes.borderLeft}></div>
                                    <button className={classes.stateElement} onClick={() => props.changeState(state.STOPPED)}>
                                        <div className={classes.stop}></div>
                                        <span className={classes.action}>
                                        {t("STOP")}
                                    </span>
                                    </button>
                                    <div className={classes.borderRight}></div>
                                </React.Fragment>:<React.Fragment></React.Fragment>)
            }
            )}
        </div>
    )

}

const useStyles = makeStyles(() => ({
    popoverContent: {
        backgroundColor: "white",
    },
    stateElement: {
        height: "50px",
        border: "none",
        outline: "none",
        borderBottom: "1px solid #DEDEDE",
        width: "calc(100% - 30px)",
        backgroundColor: "white",
        padding: "0px",
        cursor: "pointer"
    },
    play: {
        color: "#5CC958",
        height: "40px",
        width: "40px",
        float: "left"
    },
    stop: {
        height: "20px",
        width: "20px",
        backgroundColor: "#D84949",
        borderRadius: "3px",
        margin: "10px",
        marginTop: "8px",
        float: "left"
    },
    pause: {
        height: "35px",
        width: "35px",
        color: "#F59127",
        marginLeft: "5px",
        float: "left"

    },
    cancel: {
        margin: "10px",
        marginTop: "8px",
        marginLeft: "12px",
        float: "left"
    },
    done: {
        marginRight: "10px",
        marginLeft: "10px",
        float: "left",
        marginTop: "3px"

    },
    borderRight: {
        width: "15px",
        height: "50px",
        float: "right"
    },
    borderLeft: {
        width: "15px",
        height: "50px",
        float: "left"
    },
    action: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        float: "left",
        marginTop: "10px",
        marginLeft: "10px"
    },
    doneaction: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        float: "left",
        marginLeft: "10px"
    },
    planned: {
        paddingTop: "0px",
        marginRight: "10px",
        marginLeft: "10px",
        float:"left"
    },
    plannedAction:{
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        float: "left",
        marginTop: "0px",
        marginLeft: "10px"

    }

}));